import Vue from 'vue'
import Vuex from 'vuex'

import login from './modules/login'
import projectForm from './modules/projectForm'
// import tableauSurface from './modules/tableauSurface'
import schemaFonctionnel from './modules/schemaFonctionnel'
import tableau from './modules/tableau'
import actionState from './modules/actionState'
import ficheEspace from './modules/ficheEspace'
import comments from './modules/comments'
import descriptionEspace from './modules/descriptionEspace'
import articleCahier from './modules/articleCahier'
import statistiques from './modules/statistiques'
import message from './modules/messageState'
import colors from './modules/colors'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    login,
    actionState,
    projectForm,
    descriptionEspace,
    schemaFonctionnel,
    tableau,
    ficheEspace,
    comments,
    articleCahier,
    statistiques,
    message,
    colors
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js